import React from 'react'
import c from 'state/constants'
import NavBar from './NavBar'
import styles from './client.scss'
import i18n from 'lib/i18n'
const _ = i18n('mainES')

const ContractIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="22" height="30" viewBox="0 0 22 30" fill="#BCBCBC"><path d="M14.5 7.5v-7l7 7h-7zm7.35-.35l-7-7c-.1-.1-.22-.15-.35-.15H.5C.22 0 0 .22 0 .5v29c0 .27.22.5.5.5h21c.28 0 .5-.23.5-.5v-22c0-.13-.05-.26-.15-.35z"/></svg>
)

const ClaimIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="22" height="30" viewBox="0 0 22 30" fill="#BCBCBC"><path d="M21.12 12.27c-.08-.16-.26-.27-.45-.27H11.2L13.6.6c.05-.23-.07-.46-.3-.56-.2-.1-.46-.02-.6.17L.1 18.2c-.12.17-.13.37-.04.53.08.17.25.27.44.27h9.46L7.58 29.4c-.06.22.06.45.28.55.06.03.13.05.2.05.16 0 .3-.07.4-.2l12.62-17c.1-.15.13-.36.04-.53"/></svg>
)

const WebappIcon = () => (
	<svg width="24px" height="24px" viewBox="0 0 24 24">
		<g id="Page-1" fill="#BCBCBC" fillRule="evenodd">
			<g id="webapps-card@2x" transform="translate(-32.000000, -1004.000000)">
				<g id="sidebar">
					<g id="webapps" transform="translate(0.000000, 976.000000)">
						<g id="icn-webapps" transform="translate(32.000000, 28.000000)">
							<path d="M10.5,10.5 L0.5,10.5 L0.5,0.5 L10.5,0.5 L10.5,10.5 Z" id="Stroke-431"></path>
							<path d="M23.5,10.5 L13.5,10.5 L13.5,0.5 L23.5,0.5 L23.5,10.5 Z" id="Stroke-432"></path>
							<path d="M10.5,23.5 L0.5,23.5 L0.5,13.5 L10.5,13.5 L10.5,23.5 Z" id="Stroke-433"></path>
							<path d="M23.5,23.5 L13.5,23.5 L13.5,13.5 L23.5,13.5 L23.5,23.5 Z" id="Stroke-434"></path>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
)

const NewsIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 18" fill="#BCBCBC"><path d="M10 3.98c0-1.5 3.86-2.7 8.63-2.7v12.7c-4.77 0-8.63 1.2-8.63 2.7 0-1.5-3.86-2.7-8.63-2.7V1.28c4.77 0 8.63 1.2 8.63 2.7zm0 0v12.57M8.13 5.7c-1.2-.47-2.92-.82-4.88-.95M8.13 8c-1.2-.47-2.92-.8-4.88-.95m4.88 3.27c-1.2-.48-2.92-.82-4.88-.96m4.88 3.26c-1.2-.47-2.92-.8-4.88-.95m8.63-5.97c1.2-.47 2.9-.82 4.87-.95M11.88 8c1.2-.47 2.9-.8 4.87-.95m-4.87 3.27c1.2-.48 2.9-.82 4.87-.96m-4.87 3.26c1.2-.47 2.9-.8 4.87-.95"/></svg>
)

const AvatarIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="58" height="58" viewBox="0 0 58 58" fill="#BCBCBC"><path d="M48.627 47.026c-2.532-1.502-6.336-2.884-10.365-4.344-1.006-.362-2.03-.734-3.063-1.116v-4.432c1.2-.744 3.32-2.66 3.57-7.047.923-.542 1.51-1.745 1.51-3.288 0-1.39-.475-2.51-1.25-3.11.582-1.82 1.634-5.15.923-7.99-.83-3.33-5.347-4.51-8.964-4.51-3.22 0-7.158.94-8.564 3.494-1.693-.08-2.63.657-3.1 1.274-1.523 2.01-.52 5.683.05 7.706-.79.6-1.273 1.72-1.273 3.127 0 1.543.585 2.746 1.514 3.288.254 4.39 2.37 6.305 3.573 7.05v4.436c-.923.342-1.87.688-2.82 1.03-3.89 1.41-7.89 2.87-10.577 4.46-4.505-4.89-7-11.184-7-17.86 0-14.557 11.843-26.4 26.4-26.4 14.558 0 26.4 11.843 26.4 26.4 0 6.662-2.485 12.945-6.973 17.826M29.2.4C13.32.4.4 13.32.4 29.2c0 7.63 2.956 14.824 8.327 20.25v.003C14.182 54.966 21.452 58 29.2 58c7.76 0 15.042-3.046 20.5-8.576C55.052 43.998 58 36.817 58 29.2 58 13.32 45.08.4 29.2.4"/></svg>
)
const Brand = () => (
	<img src={require('resources/easinsure/easinsure-logotype.svg')}/>
)
const ClientNavBar = ({module, clientName, onLinkClicked, className, isPhone, isTablet}) => {
	const leftItems = [
		{
			id: c.NEWS,
			icon: <NewsIcon/>,
			title: _('news'),
		}, {
			id: c.CONTRACTS,
			icon: <ContractIcon/>,
			title: _('contracts'),
		}, {
			id: c.CLAIMS,
			icon: <ClaimIcon/>,
			title: _('claims'),
		}, {
			id: c.WEBAPPS,
			icon: <WebappIcon/>,
			title: _('webapps'),
		},
	]
	const rightItems = [
		{
			id: c.PROFILE,
			icon: <AvatarIcon/>,
			title: clientName,
		},
	]
	return (
		<NavBar
			activeId={module}
			brand={<Brand/>}
			onClick={onLinkClicked}
			leftItems={leftItems}
			rightItems={rightItems}
			userStyles={styles}
			className={className}
			isPhone={isPhone}
			isTablet={isTablet}
		/>
	)
}
export default ClientNavBar



// WEBPACK FOOTER //
// ./elements/ClientNavBar.jsx